import axios from "axios";
import moment from "moment";
import { common } from "./../../utils";
import { API_URL } from "./../../utils/api-utils";
//Manipulate with ExecutionPlanList
export const getReportSourceBI = async (param) => {
    let url = `${API_URL.Report}/api/report/GetSourceBIReport`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};
export const getReportSplunk = async (param) => {
    let url = `${API_URL.Report}/api/report/GetSplunkReport`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};
export const getReportT1T2 = async (param) => {
    let url = `${API_URL.Report}/api/report/GetT1T2Report`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};
export const getReportPostpaid = async (param) => {
    let url = `${API_URL.Report}/api/report/GetPostpaidReport`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};
export const getReportPrepaid = async (param) => {
    let url = `${API_URL.Report}/api/report/GetPrepaidReport`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};
export const getReportRefill = async (param) => {
    let url = `${API_URL.Report}/api/report/GetRefillReport`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};
export const getReportUsage = async (param) => {
    let url = `${API_URL.Report}/api/report/GetUsageReport`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};